module.exports = __webpack_public_path__ + "img/marketing-anim.69aea4fd.gif";